import { BaseRouteService } from "core/services";

class NikoPatientTemplateRouteService extends BaseRouteService {
  constructor() {
    super("patient-templates");
  }

  find(filter) {
    return super.find(this.base + "/{?searchQuery,page,rpp,sort,embed,fields,ids,facilityOrderId,itemCategoryIds,intakeStatusIds,isUsIntakeReviewed,isInitialIntakeReviewed,showInsuranceQuestionPatients,showMissingProductNoteTemplates,templateId,nikoPatientDetailId,subCategoryName,isDiscontinued,isSalesOrder,facilityId,nikoPatientId,dos,isClinicalReviewed,isInsuranceReviewed,hasMissingDocs,clinicalStatusId,isSystemDns,isUserDns,dosDateFrom,dosDateTo,billingValidation}", filter);
  }

  get(id, options) {
    return super.get(this.base + "/{id}/{?embed,fields}", id, options);
  }

  create(resource) {
    return super.create(this.base, resource);
  }

  update(resource) {
    return super.update(this.base + `/{id}`, resource);
  }

  delete(resource) {
    return super.delete(this.base + "/{id}", resource);
  }

  updateClinicalStatus(resource) {
    return super.update(this.base + "/{id}/clinical-status", resource);
  }

  changeClinicalStatus(resource) {
    return super.update(this.base + "/{id}/clinical-status-change", resource);
  }

  hasLinkedInvoice(id) {
    return super.get(this.base + "/{id}/has-linked-invoice", id);
  }

  findMultiDosCreditCandidates(id) {
    return super.get(this.base + "/{id}/multi-dos-credit-candidates", id);
  }

  applyMultiDosCredit(resource) {
    return super.create(this.base + "/{id}/multi-dos-credit", resource);
  }

  updateDiscontinuedStatus(resource) {
    return super.update(this.base + "/{id}/discontinued-status", resource);
  }

  updateMissingProductNote(resource) {
    const path = `${this.base}/${resource.id}/update-missing-product-note`;

    const query = resource.missingProductNote && resource.missingProductNote.trim()
      ? `?missingProductNote=${encodeURIComponent(resource.missingProductNote)}`
      : '';

    const url = path + query;

    return super.update(url, resource);
  }

  updateMissingDocumentNote(resource) {
    return super.update(this.base + '/{id}/missing-document-note', resource);
  }

  updateClinicalStatusNote(resource) {
    return super.update(this.base + `/{id}/clinical-status/note`, resource);
  }

  getMedicalNecessityFormReportUrl(id) {
    return super.get(`${this.base}/medical-necessity-form-report/{id}`, id, null);
  }

  getStandardWrittenOrderReportUrl(id) {
    return super.get(`${this.base}/standard-written-order-report/{id}`, id, null);
  }

  updateCustomOrderingDoctor(resource) {
    return super.update(this.base + '/{id}/update-custom-ordering-doctor', resource);
  }

  reviewPatientTemplate(resource) {
    return super.batchUpdate(this.base + '/review-patient-template', resource);
  }

  drainageBagValidation() {
    return `${this.base}/drainage-bag-validation`;
  }

  getNikoInvoiceIds() {
    return `${this.base}/niko/invoice-ids`;
  }

  nikoProcess(resource) {
    return super.create(this.base + '/{id}/niko/process', resource);
  }

  nikoInvoice(resource) {
    return super.create(this.base + '/{id}/niko/invoice', resource);
  }

  updateClinicalInformation(resource) {
    return super.update(this.base + '/{id}/clinical-information', resource);
  }

  deleteNewTemplate(id) {
    return super.delete(`${this.base}/new/{id}`, { id });
  }

  findReplacementItems(filter) {
		return super.find(`${this.base}/get-replacement-items/{?facilityOrderId,searchQuery,productId,unitOfMeasureIdToExclude}`, filter);
	}

  createNikoMasterPatientTemplateBySubCategory() {
		return super.create(`${this.base}/create-niko-master-patient-template-by-sub-category`);
	}

  createMonthlyTubeMasterTemplates(facilityOrderId) {
    return super.create(`${this.base}/create-monthly-tube-master-templates/${facilityOrderId}`);
  }

  checkSystemDns(filter) {
    return super.find(`${this.base}/check-system-dns/{?itemCategoryId,eligibilityStatusId,facilityId}`, filter);
  }

  getAvailableBillingValidations(filter) {
    return super.find(`${this.base}/available-billing-validations/{?facilityId,nikoPatientId,itemCategoryIds,dosDateFrom,dosDateTo,isSalesOrder}`, filter);
  }
}

export default NikoPatientTemplateRouteService;

